import Request from "@/Request";

export function getParties() {
  return Request({
    url: "/parties/intending",
    method: "get",
  });
}

export function getPendingAssociation() {
  return Request({
    url: "/parties/pending",
    method: "get",
  });
}

export function getRegisteredParties() {
  return Request({
    url: "/parties/registered",
    method: "get",
  });
}

export function partyDetails(payload) {
  return Request({
    url: `parties/${payload.partyID}/details`,
    method: "get",
  });
}

export function generateCode(payload) {
  return Request({
    url: "parties/generate-code",
    method: "post",
    data: payload,
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
}

export function approveSection(payload) {
  const partyID =
    payload instanceof FormData ? payload.get("partyID") : payload.partyID;

  return Request({
    url: `parties/${partyID}/section-approval`,
    method: "post",
    data: payload,
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
}

export function getCode(payload) {
  return Request({
    url: `parties/${payload.partyID}/access-code`,
    method: "get",
  });
}
